import {
    numberFormatter,
    percentageBarFormatter,
} from "../../gridFormatters";

export const enterpriseDatabaseSummaryDefs = [
    {
        "field": "instance",
        "headerName": "Instance",
    },
    {
        "field": "host",
        "headerName": "Host",
    },
    {
        "field": "type",
        "headerName": "Database Type",
    },
    {
        "field": "allocated",
        "headerName": "Allocated",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "aggFunc": "sum",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "free",
        "headerName": "Free",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "aggFunc": "sum",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "used",
        "headerName": "Used",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "aggFunc": "sum",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "pct_used",
        "headerName": "% Used",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "aggFunc": 'avg',
        "cellRenderer": percentageBarFormatter,
    },
    {
        "field": "increment",
        "headerName": "Increment",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "aggFunc": "sum",
        "cellRenderer": numberFormatter,
    },
    {
        "field": "version",
        "headerName": "Version",
    },
]